export default "__VITE_PUBLIC_ASSET__072c798e__"